import React from 'react';
import { Link } from 'react-router-dom';
import { siteConfig } from '../data/config';

function NotFound() {
  return (
    <div className="not-found-page">
      <div className="not-found-container">
        <div className="not-found-content">
          <div className="not-found-icon">
            <i className="fas fa-search"></i>
          </div>
          
          <h1 className="not-found-title">404</h1>
          <h2 className="not-found-subtitle">Page Not Found</h2>
          
          <p className="not-found-description">
            Oops! The page you're looking for doesn't exist. 
            It might have been moved, deleted, or you entered the wrong URL.
          </p>
          
          <div className="not-found-actions">
            <Link to="/" className="btn btn-primary">
              <i className="fas fa-home"></i>
              Go Home
            </Link>
            <Link to="/contact" className="btn btn-secondary">
              <i className="fas fa-envelope"></i>
              Contact Me
            </Link>
          </div>
          
          <div className="not-found-suggestions">
            <h3>Popular Pages</h3>
            <div className="suggestions-grid">
              {siteConfig.apps.map((app) => (
                <Link key={app.id} to={app.aboutLink} className="suggestion-card">
                  <i className={app.icon}></i>
                  <span>{app.title}</span>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
